/* Honigmama – Bewegung, Einblenden, Kaufleiste */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canIO = 'IntersectionObserver' in window;
  if (!reduce && canIO) document.documentElement.classList.add('hm-motion');

  function init() {
    // Kaufformular: Zeitpunkt der Zustimmung mitschicken
    document.querySelectorAll('[data-hm-buy]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var t = f.querySelector('[data-hm-buy-time]');
        if (t) { t.disabled = false; t.value = new Date().toISOString(); }
      });
    });

    if (canIO) {
      // Honig-Bänder erst laufen lassen, wenn sie im Bild sind
      var honeyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-in', e.isIntersecting); });
      }, { rootMargin: '0px 0px -5% 0px' });
      document.querySelectorAll('.hm-honey').forEach(function (el) { honeyIO.observe(el); });

      // Inhalte nacheinander einblenden
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.hm-reveal').forEach(function (el) { revealIO.observe(el); });

      // Kaufleiste: sichtbar, wenn kein Kaufknopf im Bild ist
      var bar = document.getElementById('hm-sticky');
      var zones = Array.prototype.slice.call(document.querySelectorAll('[data-hm-cta-zone]'));
      if (bar && zones.length) {
        var visible = new Set();
        var update = function () {
          var show = visible.size === 0 && window.scrollY > 300;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          bar.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
        };
        var barIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { visible.add(e.target); } else { visible.delete(e.target); } });
          update();
        });
        zones.forEach(function (z) { barIO.observe(z); });
        window.addEventListener('scroll', update, { passive: true });
      }
    } else {
      document.querySelectorAll('.hm-reveal').forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
